export function getOpenApiHost(): string {
  switch (process.env.STAGE) {
    case "PRD":
      return "https://open-api-prd-324038082239.asia-northeast1.run.app";
    case "STG":
      return "https://open-api-stg-324038082239.asia-northeast1.run.app";
    case "DEV":
      return "https://open-api-dev-324038082239.asia-northeast1.run.app";
    default:
      return process.env.AMBII_OPEN_API_URI || "http://localhost:8081";
  }
}
